import CryptoJS from 'crypto-js';

const SECRET_KEY = 'tabtrips_hotel_secret';

/**
 * Encrypts hotel ID for secure URL parameter
 * @param {string|number} hotelId - The hotel ID to encrypt
 * @returns {string} - Encrypted hotel ID
 */
export const encryptHotelId = (hotelId) => {
  return CryptoJS.AES.encrypt(hotelId.toString(), SECRET_KEY).toString();
};

/**
 * Decrypts hotel ID from URL parameter
 * @param {string} encryptedHotelId - The encrypted hotel ID
 * @returns {string|null} - Decrypted hotel ID or null if invalid
 */
export const decryptHotelId = (encryptedHotelId) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedHotelId, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return null;
  }
};

/**
 * Generates a secure PayInvoice URL
 * @param {string|number} hotelId - The hotel ID
 * @param {string} baseUrl - Base URL (optional, defaults to current origin)
 * @returns {string} - Complete secure URL for PayInvoice page
 */
export const generatePayInvoiceUrl = (hotelId, baseUrl = window.location.origin) => {
  const encryptedHotelId = encryptHotelId(hotelId);
  // Properly encode the encrypted token for URL
  const encodedToken = encodeURIComponent(encryptedHotelId);
  return `${baseUrl}/pay-invoice?hotel=${encodedToken}`;
};

/**
 * Validates if a PayInvoice URL is properly formatted
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if URL is valid
 */
export const isValidPayInvoiceUrl = (url) => {
  try {
    const urlObj = new URL(url);
    const encryptedHotelId = urlObj.searchParams.get('hotel');
    return encryptedHotelId && decryptHotelId(encryptedHotelId) !== null;
  } catch {
    return false;
  }
};
